import { render, staticRenderFns } from "./HazardTypeList.vue?vue&type=template&id=9e4e6434"
import script from "./HazardTypeList.vue?vue&type=script&lang=js"
export * from "./HazardTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports